module.exports = __webpack_public_path__ + "assets/img/EXCLUSIVE_GATEWAY_PLUGIN.85e846eb.svg";